/* eslint max-statements: 0 */
import $ from '../../../util/jquery-wrapper';
import _ from '../../../util/underscore-wrapper';
import SchemaUtil from '../../../util/SchemaUtil';
import StringUtil from '../../../util/StringUtil';
const NAME = 'name';
const ENUM_KEY_PREFIX = '_enum_';

/**
 * Generate Input Options in order to create an input in an Form for Enum type attribute.
 * @param {Object} config informations for creating input options
 *   config.name        schema property name
 *   config.title       schema property title
 *   config.readOnly    create an read only input?
 *   config.explain     sub-title to the input
 *   config.enumValues  list of enum values for creating input options (Dropdown/SimpleCheckBoxSet)
 *   config.displayType display type of schema property
 *
 * @return {Object} inputOptions options for create an Input view. (Dropdown/SimpleCheckBoxSet)
 *
 */
function getEnumInputOptions(config) {
  const enumOneOf = convertToOneOf(config.enumValues);
  const inputOptions = {
    name: config.name,
    label: config.title,
    readOnly: config.readOnly,
    customExplain: config.explain,
    params: { enumOneOf: enumOneOf },
    options: getDropdownOptionsFromOneOf(enumOneOf)
  };

  // input type
  if (SchemaUtil.isArrayDataType(config.displayType)) {
    inputOptions.type = 'checkboxset';
    inputOptions.to = valuesToEnumObjects;
    inputOptions.from = enumObjectsToValues;
  } else {
    inputOptions.type = 'select';
    inputOptions.to = valueToEnumObject;
    inputOptions.from = enumObjectToValue;
  }

  inputOptions.input = null;
  return inputOptions;
}

function getDropdownOptions(values) {
  return _.isArray(values) ? getDropdownOptionsFromOneOf(convertToOneOf(values)) : {};
}

function getDropdownOptionsFromOneOf(values) {
  if (!isOneOfEnumObject(values)) {
    return {};
  }

  return _.reduce(
    values,
    function (options, value, index) {
      options[convertIndexToEnumIndex(index)] = value.title;
      return options;
    },
    {}
  );
}

function convertToOneOf(values) {
  // assume this is a legacy enum array and convert to oneOf object
  if (!_.all(values, $.isPlainObject)) {
    return convertEnumToOneOf(values);

    // we assume object without const and title is an enum object which need special conversion
  } else if (!isOneOfEnumObject(values)) {
    return convertEnumObjectToOneOf(values);
  }

  return values;
}

function isOneOfEnumObject(values) {
  return (
    _.isArray(values) &&
    _.all(values, function (value) {
      return _.has(value, 'const') && _.has(value, 'title');
    })
  );
}

function convertEnumToOneOf(values) {
  return _.map(values, function (value) {
    return {
      const: value,
      title: valueToTitle(value)
    };
  });
}

function valueToTitle(value) {
  if (_.isObject(value)) {
    return JSON.stringify(value);
  }

  if (_.isNumber(value)) {
    return value + '';
  }

  return value;
}

function convertEnumObjectToOneOf(values) {
  const findKey = _.partial(_.has, _, NAME);
  // If all object found the key NAME, use the NAME's value as display name

  if (_.all(values, findKey)) {
    return _.chain(values)
      .filter(function (value) {
        return $.isPlainObject(value) && _.has(value, NAME);
      })
      .map(function (value) {
        return { const: value, title: value[NAME] };
      })
      .value();
  }

  // Assume a legacy object array does not need special handling and just convert to const/title enum
  return convertEnumToOneOf(values);
}

function convertIndexToEnumIndex(index) {
  return `${ENUM_KEY_PREFIX}${index}`;
}

function enumObjectToValue(obj) {
  const index = _.findIndex(this.options.params.enumOneOf, function (oneOfObj) {
    return _.isObject(obj) ? _.isEqual(oneOfObj.const, obj) : oneOfObj.const === obj;
  });
  // Cannot rely on comparator in findIndex when compare objects so need special handling

  return index > -1 ? convertIndexToEnumIndex(index) : obj;
}

function valueToEnumObject(val) {
  if (!_.isString(val) || val.indexOf(ENUM_KEY_PREFIX) !== 0) {
    return val;
  }

  const index = val.replace(ENUM_KEY_PREFIX, '');
  const enumValue =
    this.options.params && _.isArray(this.options.params.enumOneOf) ? this.options.params.enumOneOf[index] : null;

  // @see `getEnumInputOptions` how enumValues has been set.

  return _.has(enumValue, 'const') ? enumValue.const : enumValue;
}

function valuesToEnumObjects(values) {
  return _.map(values, valueToEnumObject.bind(this));
}

function enumObjectsToValues(values) {
  return _.map(values, enumObjectToValue.bind(this));
}

function isStringConstraint(value) {
  return _.isString(value) && $.trim(value) !== '';
}

function isNumberConstraint(value) {
  return _.isNumber(value) || _.isNumber(StringUtil.parseFloat($.trim(value)));
}

function isIntegerConstraint(value) {
  const integer = _.isNumber(value) ? value : StringUtil.parseInt($.trim(value));

  return typeof integer === 'number' && isFinite(integer) && Math.floor(integer) === integer;
}

function isObjectConstraint(value) {
  if (_.isObject(value) && !_.isArray(value)) {
    return true;
  }

  const object = StringUtil.parseObject($.trim(value));

  return _.isObject(object) && !_.isArray(object);
}

function isConstraintValueMatchType(value, type) {
  switch (type) {
  case SchemaUtil.STRING:
    return isStringConstraint(value);
  case SchemaUtil.NUMBER:
    return isNumberConstraint(value);
  case SchemaUtil.INTEGER:
    return isIntegerConstraint(value);
  case SchemaUtil.OBJECT:
    return isObjectConstraint(value);
  }
}

export default {
  getEnumInputOptions: getEnumInputOptions,
  getDropdownOptions: getDropdownOptions,
  convertToOneOf: convertToOneOf,
  isConstraintValueMatchType: isConstraintValueMatchType
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/helpers/EnumTypeHelper.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/views/forms/helpers/EnumTypeHelper.js